import { NodeEventPlugin } from '@lexical/react/LexicalNodeEventPlugin';
import { $getNodeByKey, LexicalEditor, NodeKey } from 'lexical';
import {
  $acceptInlineSuggestion,
  $isInlineSuggestionNode,
  $rejectInlineSuggestion,
  InlineSuggestionNode,
} from '../nodes/InlineSuggestionNode';
import {
  $acceptSuggestion,
  $isSuggestionNode,
  $rejectSuggestion,
  SuggestionNode,
} from '../nodes/SuggestionNode';

export function SuggestionActionPlugin() {
  const handleClick = (e: Event, eventEditor: LexicalEditor, key: NodeKey) => {
    if (!('originalTarget' in e)) {
      return;
    }

    const originalTarget = e.originalTarget as HTMLElement | null;
    if (!originalTarget) {
      return;
    }

    const target = originalTarget.closest('[data-intent]') as HTMLElement | null;
    if (!target) {
      return;
    }

    const intent = target.dataset.intent;
    if (!intent) {
      return;
    }

    eventEditor.update(() => {
      const node = $getNodeByKey(key);
      if (!node) {
        return;
      }

      if (!$isSuggestionNode(node) && !$isInlineSuggestionNode(node)) {
        return;
      }

      if (intent === 'accept') {
        if ($isSuggestionNode(node)) {
          $acceptSuggestion(node);
        } else if ($isInlineSuggestionNode(node)) {
          $acceptInlineSuggestion(node);
        }
      } else if (intent === 'reject') {
        if ($isSuggestionNode(node)) {
          $rejectSuggestion(node);
        } else if ($isInlineSuggestionNode(node)) {
          $rejectInlineSuggestion(node);
        }
      }

      node.selectNext();
    });
  };

  return (
    <>
      {[SuggestionNode, InlineSuggestionNode].map(nodeType => (
        <NodeEventPlugin
          key={nodeType.name}
          nodeType={nodeType}
          eventType={'click'}
          eventListener={handleClick}
        />
      ))}
    </>
  );
}
